/**
 * Return a fancy price format if price has no cents
 * @param {Number} value - price to checkk
 * @returns {string}
 */
export function formatPriceFancy(number) {
    // add the the –. before the number if it's smaller than 1
    if (number < 1 && number) {
        const defaultFormatting = formatPrice(number);
        return `–.${ defaultFormatting.slice(defaultFormatting.length - 2, defaultFormatting.length) }`;
    }

    return Math.floor(number) === number ? `${ number }.–` : `${ formatPrice(number) }`;
}

/**
  * Format the products prices
  * @param number
  * @returns {string}
  */
export function formatPrice(number) {
    return Number(number) ? Number(number).toFixed(2) : '0.00';
}

export default formatPrice;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/format-price.js